export function Content(props) {
    const RenderComponent = props.component;
    return (
        <div className={'no-feedback-main'}>
            <h2 className={'content-page-title'}>
                {props.title}
            </h2>
            {props.subtitle && <><p className={'content-page-subtitle'}>
                {props.subtitle}
            </p></>}
            {RenderComponent ? <RenderComponent/> : <p className={'description-text'}>{props.text} {props.link && <p><a target={'_blank'} className={'description-text underline-text'} href={props.link}>{props.linktext}</a></p>}</p>}
            {props.imgUrl && <img className={'content-img'} src={props.imgUrl}/>}
        </div>
    );
}
